import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import React, { useEffect, useState } from 'react';
import { getFormattedDateBasedOnTerritory } from 'utils/defaultsByTerritory';

import TextField from '@material-ui/core/TextField';

import DateTimePickerDialog from './DateTimePickerDialog';

interface DateTimePickerProps {
  value: Date | null;
  name: string;
  label: string;
  initialFocusedDate: Date;
  onChange: (value: Date | null) => void;
  onClose: () => void;
  disabled?: boolean;
  disablePast?: boolean;
  clearable?: boolean;
  'data-tc': string;
}

const DateTimePicker = ({
  value,
  name,
  label,
  initialFocusedDate,
  onChange,
  onClose,
  disabled = false,
  disablePast = false,
  clearable = true,
  'data-tc': dataTc,
}: DateTimePickerProps) => {
  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();

  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    value ? getFormattedDateBasedOnTerritory(value, activeTerritory, true) : ''
  );

  useEffect(() => {
    setSelectedValue(
      value
        ? getFormattedDateBasedOnTerritory(value, activeTerritory, true)
        : ''
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (updatedValue: Date | null) => {
    onChange(updatedValue);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <>
      <TextField
        label={label}
        name={name}
        id={name}
        data-tc={dataTc}
        value={selectedValue}
        onClick={() => setOpen(!disabled)}
        inputProps={{
          readOnly: true,
        }}
        disabled={disabled}
      />
      <DateTimePickerDialog
        value={value}
        initialFocusedDate={initialFocusedDate}
        open={open}
        onClose={handleClose}
        onChange={handleChange}
        disablePast={disablePast}
        clearable={clearable}
      />
    </>
  );
};

export default DateTimePicker;
